import { PERMISSIONS } from '../constants/roles.constant';

/**
 * O backend expõe permissões granulares (`resource.action`, ex.: "deal.read"); o menu/guards
 * do frontend só precisam de um sinal por seção (ex.: "crm.manage"). Esta função deriva o
 * segundo a partir do primeiro, em vez de manter duas fontes de verdade independentes.
 */
export function derivePermissions(permissionSlugs = []) {
  const has = (prefix) => permissionSlugs.some((slug) => slug.startsWith(prefix));
  const derived = new Set();

  if (has('report.')) {
    derived.add(PERMISSIONS.DASHBOARD_VIEW);
    derived.add(PERMISSIONS.REPORTS_VIEW);
  }
  if (has('conversation.')) {
    derived.add(PERMISSIONS.CONVERSATIONS_VIEW);
    derived.add(PERMISSIONS.SUPPORT_MANAGE);
  }
  if (has('deal.') || has('pipeline.') || has('product.')) {
    derived.add(PERMISSIONS.CRM_MANAGE);
  }
  if (has('order.') || has('payment.')) {
    derived.add(PERMISSIONS.SALES_MANAGE);
  }
  if (has('flow.') || has('bot.') || has('template.') || has('quick_reply.')) {
    derived.add(PERMISSIONS.AUTOMATION_MANAGE);
  }
  if (has('campaign.')) {
    derived.add(PERMISSIONS.CAMPAIGNS_MANAGE);
  }
  if (has('team.') || has('user.') || has('role.') || has('permission.')) {
    derived.add(PERMISSIONS.TEAMS_MANAGE);
  }
  if (
    has('settings.') ||
    has('channel.') ||
    has('integration.') ||
    has('feature_flag.') ||
    has('audit.')
  ) {
    derived.add(PERMISSIONS.SETTINGS_MANAGE);
  }

  return Array.from(derived);
}

export default derivePermissions;
